<template>
  <b-textarea :value="text" @change="textAreaChanged" />
</template>

<script>
export default {
  props: ["text", "property", "itemId"],
  methods: {
    textAreaChanged(newValue) {
      // NOTE: We may do it on focus out
      this.$emit("update", {
        itemId: this.itemId,
        value: newValue,
        property: this.property,
      });
    },
  },
};
</script>
